import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const ItemList = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1. Direct fetch to your verified URL
    fetch("https://ca2-team11-server-0rto.onrender.com/allrecyclable")
      .then(res => res.json())
      .then(data => {
        console.log("SUCCESS! Data received:", data);
        
        // 2. Ensure we are setting an array
        // Your SQL sends rows directly, so data should be the array.
        if (Array.isArray(data)) {
          setItems(data);
        } else if (data.rows) {
          setItems(data.rows);
        }
        
        setLoading(false);
      })
      .catch(err => {
        console.error("Fetch Error:", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <div style={{padding: '20px'}}>Connecting to SQL...</div>;

  return (
    <div className="list-container" style={{ padding: '20px' }}>
      <h2>Recyclable Items ({items.length})</h2>
      
      <div className="item-grid" style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', 
        gap: '20px',
        marginTop: '20px'
      }}>
        {items.length > 0 ? (
          items.map((item) => (
            <div key={item.id} className="item-card" style={{ 
              border: '1px solid #ccc', 
              borderRadius: '10px', 
              padding: '15px',
              textAlign: 'center',
              boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
            }}>
              <img 
                src={item.image} 
                alt={item.name} 
                style={{ width: '100%', height: '180px', objectFit: 'cover', borderRadius: '5px' }} 
              />
              <h3 style={{ margin: '15px 0 5px' }}>{item.name}</h3>
              <p style={{ color: '#666', fontSize: '0.9rem' }}>Material: {item.material}</p>
              <p style={{ fontWeight: 'bold' }}>Qty: {item.quantity}</p>
              <Link 
                to={`/item/${item.id}`} 
                style={{ 
                  display: 'inline-block', 
                  marginTop: '10px', 
                  color: '#007bff', 
                  textDecoration: 'none',
                  fontWeight: '500' 
                }}
              >
                Edit Details →
              </Link>
            </div>
          ))
        ) : (
          <p>No items found in the database table.</p>
        )}
      </div>
    </div>
  );
};

export default ItemList;